<template>
  <div>
    <div class="indent" v-loading="queryOrderLoading">
      <el-alert
        type="warning"
        title="您没有下订单权限，请联系管理员"
        v-if="!havePerm('User.EntOrder.Create')"
      ></el-alert>
      <div class="mys">确认订单</div>
      <el-row class="orderBox">
        <el-col v-for="item in appInfoList" :key="item.name" :span="item.span">
          <div class="order-content">{{ item.name }}</div>
        </el-col>
      </el-row>

      <el-row class="orderBoxChild">
        <el-col :span="8">
          <div class="order-content">{{ appData.name || '-' }}</div>
        </el-col>
        <el-col :span="8">
          <div class="order-content">{{ version || '-' }}</div>
        </el-col>
        <el-col :span="8">
          <div class="order-content">{{ packagesInfo.name }}</div>
        </el-col>
      </el-row>

      <el-row class="orderBox">
        <el-col
          v-for="item in serviceProvidersInfoList"
          :key="item.name"
          :span="item.span"
        >
          <div class="order-content">{{ item.name }}</div>
        </el-col>
      </el-row>

      <el-row class="orderBoxChild">
        <el-col :span="4">
          <div class="order-content">{{ appData.marketName }}</div>
        </el-col>

        <el-col :span="4">
          <div class="order-content">
            {{
              packagesInfo.billtype === 'item'
                ? '按服务周期计费'
                : '按服务周期计费'
            }}
          </div>
        </el-col>

        <el-col :span="4">
          <div class="order-content">
            {{ useCycle[packagesInfo.billCycle] || '-' }}
          </div>
        </el-col>
        <el-col :span="4">
          <div class="order-content colorprice">
            {{ `${packagesInfo.price}元` || 0 }}
          </div>
        </el-col>
        <el-col :span="4">
          <div class="order-content">
            <el-input-number
              :disabled="type && type === 'trial'"
              v-model="num"
              @change="handleSaaSDateChange"
              :min="1"
              size="mini"
              class="customNumber"
            ></el-input-number>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="order-content colorprice">{{ totalPrice }}元</div>
        </el-col>
      </el-row>
    </div>
    <div class="remark">
      <p>备注</p>
      <el-input
        class="inputtxet"
        type="textarea"
        :rows="2"
        maxlength="255"
        show-word-limit
        resize="none"
        placeholder="请填写备注内容，限255字"
        v-model="note"
      ></el-input>
    </div>
    <div class="hint">
      <div>温馨提示</div>
      <div class="hint-text">
        <span>
          1.
          为了让服务商更好的服务您，下单后系统会将当前账号下的联系方式传递给服务商
        </span>
        <span>2. SasS服务商场将自动交付独立服务，并提供给你访问和使用权限</span>
      </div>
    </div>
    <div class="priceFoot">
      <div v-if="serviceTime" class="left">
        服务预计到期时间：{{ serviceTime }}
      </div>
      <div class="right">
        <div class="lh40">总计：{{ finalPrice }} 元</div>
        <div
          @click="createOrder"
          v-permit="'User.EntOrder.Create'"
        >
          <el-button class="customBtn w160" :loading="payLoading">{{
            payLoading ? '订单信息生成中' : '提交订单'
          }}</el-button>
        </div>
      </div>
    </div>
    <div class="bo"></div>
  </div>
</template>
<script>
import { getAppDetailApi } from '@/api/appStore';
import { errorHandle } from '@/utils/error';
import { havePerm } from '@/utils/auth';
import moment from 'moment';

export default {
  name: 'ConfirmOrder',
  components: {
  },
  data() {
    return {
      havePerm,
      moment,
      userEID: '',
      packageID: '1234567890',
      appEID: '',
      eid: '',
      packagesInfo: {},
      appData: Object.assign({}),
      appKeyID: '',
      appVersion: '',
      note: '',
      saasProvider: [],
      serviceProvidersInfoList: [
        { name: '服务商', span: 4 },
        {
          name: '付费方式',
          span: 4
        },
        {
          name: '购买周期',
          span: 4
        },
        {
          name: '单价',
          span: 4
        },
        {
          name: '数量',
          span: 4
        },
        {
          name: '总价',
          span: 4
        }
      ],
      appInfoList: [
        {
          name: '应用名称',
          span: 8
        },
        {
          name: '版本',
          span: 8
        },
        {
          name: '套餐',
          span: 8
        }
      ],
      useCycle: {
        week: '周付',
        month: '月付',
        quarter: '季付',
        year: '年付'
      },
      selectProvider: {
        base: 'free'
      },
      cycleMap: {
        week: 7,
        month: 1,
        season: 9,
        years: 12
      },
      selectProviderID: '',
      price: 0,
      num: 1,
      totalPrice: 0,
      finalPrice: 0,
      payLoading: false,
      queryOrderLoading: false,
      type: '',
      version: '',
      serviceTime: '',
      // 微信支付相关
      wechatPayVisible: false,
      wechatPayCodeUrl: '',
      wechatPayAmount: 0,
      wechatPayExpireTime: null,
      currentOrderID: ''
    };
  },
  watch: {
    totalPrice() {
      this.finalPrice = this.totalPrice;
    }
  },
  computed: {
    enterpriseInfo() {
      return this.$store.state.enterprise.enterpriseInfo;
    }
  },
  created() {
    const { marketID, appID, type, packageID, version } = this.$route.query;
    if (marketID && appID && type && packageID && version) {
      this.marketID = marketID;
      this.appID = appID;
      this.type = type;
      this.packageID = packageID;
      this.version = version;
      this.getAppDetail();
    } else {
      this.$router.go(-1);
      return null;
    }
  },
  methods: {
    getAppDetail() {
      this.queryOrderLoading = true;
      getAppDetailApi({ marketId: this.marketID, appId: this.appID })
        .then((res) => {
          if (res) {
            this.appData = res;
            if (res.packages && res.packages.length > 0) {
              this.packagesInfo = res.packages.filter((item) => {
                return item.packageID === this.packageID;
              })[0];
            }
            const { price, billCycle } = this.packagesInfo;
            if ((price == 0 || price) && billCycle) {
              this.handleSaaSDateChange(1);
            }
          }
          this.queryOrderLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.queryOrderLoading = false;
          this.$message.error('获取订单信息失败');
        });
    },
    getBillCycleDay(cycle, value) {
      let dataStr = '';
      switch (cycle) {
        case 'week':
          dataStr = moment().add(1 * value, 'weeks');
          break;
        case 'month':
          dataStr = moment().add(1 * value, 'months');
          break;
        case 'year':
          dataStr = moment().add(1 * value, 'years');
          break;
        case 'quarter':
          dataStr = moment().add(3 * value, 'months');
          break;
      }
      return moment(dataStr).locale('zh-cn').format('YYYY年MM月DD日');
    },
    handleSaaSDateChange(value) {
      const { price, billCycle } = this.packagesInfo;
      this.totalPrice = price ? price * value : 0;
      this.serviceTime = this.getBillCycleDay(billCycle, value);
      this.num = value;
    },
    changeCycle(value) {
      this.selectProvider.base = value;
      const { price } = this.packagesInfo;
      this.totalPrice = price ? price * this.num : 0;
    },
    createOrder() {
      this.payLoading = true;
      this.$store
        .dispatch('CreateOrder', {
          finalPrice: this.finalPrice,
          marketID: this.marketID,
          orderType: this.type,
          totalPrice: this.totalPrice,
          note: this.note,
          orderApps: [
            {
              appID: this.appData.appKeyID,
              appVersion: this.packagesInfo.version,
              comboID: this.packagesInfo.packageID,
              comboQuantity: this.num
            }
          ]
        })
        .then((res) => {
          if (res && res.orderID) {
            this.currentOrderID = res.orderID;
            // 创建订单成功后，调用微信支付
            this.createWechatPayOrder(res.orderID);
          } else {
            this.payLoading = false;
          }
        })
        .catch((err) => {
          if (err.code == 6016) {
            const router = this.$router;
            this.$confirm(
              '企业未完成实名认证，需完成实名认证方可购买应用?',
              '提示',
              {
                confirmButtonText: '去认证',
                cancelButtonText: '取消',
                type: 'warning'
              }
            )
              .then(() => {
                router.push({ name: 'basic', query: { tab: 'auth' }});
              })
              .catch(() => {
                this.payLoading = false;
              });
            return;
          }
          errorHandle(err);
          this.payLoading = false;
        });
    },
    // 创建微信支付订单
    createWechatPayOrder(orderID) {
      this.$store
        .dispatch('CreateWechatPay', orderID)
        .then((res) => {
          this.payLoading = false;
          if (res && res.data) {
            const { codeUrl, amount, expireTime } = res.data;
            this.wechatPayCodeUrl = codeUrl;
            this.wechatPayAmount = amount;
            this.wechatPayExpireTime = expireTime;
            this.wechatPayVisible = true;
          }
        })
        .catch((err) => {
          this.payLoading = false;
          errorHandle(err);
        });
    },
    // 支付成功处理
    handlePaySuccess() {
      this.wechatPayVisible = false;
      this.$message.success('支付成功');
      this.$router.push({
        name: 'payStatus',
        params: {
          orderID: this.currentOrderID
        }
      });
    },
    // 取消支付处理
    handlePayCancel() {
      this.wechatPayVisible = false;
      this.$message.info('已取消支付');
      // 跳转到订单详情页
      this.$router.push({
        name: 'myorderDetails',
        params: {
          orderId: this.currentOrderID
        }
      });
    },
    // 刷新二维码
    handlePayRefresh() {
      this.createWechatPayOrder(this.currentOrderID);
    },
    // 二维码过期处理
    handlePayExpired() {
      this.$message.warning('支付二维码已过期，请刷新重试');
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.w160 {
  width: 160px;
}
.customNumber ::v-deep .el-input-number__decrease,
::v-deep .el-input-number__increase {
  background: none !important;
}
.mys {
  height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(84, 88, 90, 1);
  line-height: 40px;
  border-bottom: 1px solid #54585a;
  margin-bottom: 10px;
}

.orderBox {
  background: #e6eff8;
  height: 42px;
  line-height: 42px;
  text-align: center;
  margin-top: 20px;
}
.orderBox div:nth-of-type(1) div {
  margin-left: 9px;
  text-align: left;
}

.orderBoxChild {
  display: flex;
  align-items: center;
  height: 45px;
  margin: 10px 9px;
}
.order-content {
  font-size: 14px;
  text-align: center;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #999999;
}

.orderBoxChild .order-content {
  color: rgba(84, 88, 90, 1);
}
.orderBoxChild div:nth-of-type(1) > div {
  text-align: left;
}
.colorprice {
  color: #ffa500;
}

.inputtxet {
  padding: 12px 0 20px 0;
}
::v-deep .inputtxet .el-input__count {
  right: 0 !important;
}
.lh40 {
  line-height: 40px;
}
.remark p:nth-of-type(1) {
  height: 40px;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(84, 88, 90, 1);
  line-height: 40px;
  border-bottom: 1px solid #54585a;
}
.hint div:nth-of-type(1) {
  height: 40px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(84, 88, 90, 1);
  line-height: 40px;
  font-size: 14px;
  border-bottom: 1px solid rgb(211, 206, 206);
  margin-bottom: 10px;
}
.hint-text span {
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: rgba(84, 88, 90, 1);
  font-size: 14px;
  color: #8b8b7a;
  display: block;
  line-height: 22px;
}
.priceFoot {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .right {
    display: flex;
    justify-content: space-between;
  }
  .desc {
    font-size: 20px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    line-height: 45px;
    color: #1890ff;
  }
  button {
    margin-left: 60px;
  }
}

.bo {
  padding-bottom: 80px;
}
.workname {
  padding-left: 0;
}
.appname {
  position: relative;
  top: 20px;
}
.white_Two {
  margin-top: 20px;
}
.el-input-number--mini {
  width: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/pay/confirmOrder/index.vue